import CommonDialog from '@/components/common/dialog/CommonDialog.vue'
import MiiaFwConfig from '@/configs/config'
import { useUserManagementStore } from '@/stores/userManagementStore'
import type { UpdateAccountRequestParam } from '@/types/api/dupAuth/updateAccountRequestParam'
import { useTemplateRef } from 'vue'

export const useUserDeleteConfirmDialog = () => {
  const commonDialog = useTemplateRef<InstanceType<typeof CommonDialog>>('commonDialog')
  const userManagementStore = useUserManagementStore()

  /**
   * ユーザー削除確認ダイアログを開く関数。
   * ダイアログの開閉成否を Promise で通知する。
   * @returns {Promise<boolean>} ダイアログ開閉成功時は true を返す
   */
  const openDialog = async (): Promise<boolean> => {
    if (!commonDialog.value) {
      return false
    }
    return await commonDialog.value
      ?.openDialog()
      .then(() => true)
      .catch(() => false)
  }

  /**
   * 指定されたユーザーIDのユーザーを削除済み状態に更新する関数。
   * APIパラメータを組み立てて状態管理ストアの更新処理を呼び出す。
   * @param userId - 削除対象のユーザーID
   */
  const deleteUser = async (userId: string) => {
    const params: UpdateAccountRequestParam = {
      system: MiiaFwConfig.config.sysId,
      userId: userId,
      deleted: true
    }
    await userManagementStore.fetchUpdateUserField(params)
  }

  return {
    openDialog,
    deleteUser
  }
}
